/**
 * @desc 查看工艺监控画面
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ProcessMonitorCurveRequest,
): Promise<defs.StandardReturn<Array<defs.ProcessMonitorResponse>>> {
  return defHttp.post({
    url: '/wap/ProductionRealTime/getProcessMonitorScreen',
    data,
  });
}

export function mock(
  data: defs.ProcessMonitorCurveRequest,
): Promise<defs.StandardReturn<Array<defs.ProcessMonitorResponse>>> {
  return defHttp.post({
    url: '/mock/wap/ProductionRealTime/getProcessMonitorScreen',
    data,
  });
}
